/// <reference path="appbase.ts" />

namespace TerminalApp {
    export class Homescreen extends AppBase {
        static instance: Homescreen;
        container = document.getElementById("homescreen");
        apps = container.querySelector(".app_icons");
        clear = document.createElement("div");
        icon_counts: { [appid: string]: HTMLElement } = {}
        icon_counts2: { [appid: string]: HTMLElement } = {}
        constructor() {
            super("homescreen");
            Homescreen.instance = this;
            this.clear.classList.add("clear");
        }

        addApp(appId: string, image: string, name: string) {
            var gridItem = this.apps.appendChild(document.createElement("div"));
            this.container.appendChild(this.clear);
            gridItem.classList.add("grid_item");


            var button = gridItem.appendChild(document.createElement("div"));
            button.classList.add("app_button");

          

            button.innerHTML = `<img src="${image}" /><span class="text">${name}</span>`

            var count = document.createElement("div");
            count.classList.add("app_number");
            count.style.display = "none";
            button.appendChild(count);

            var count2 = document.createElement("div");
            count2.classList.add("app_number", "app_number2");
            count2.style.display = "none";
            button.appendChild(count2);

            this.icon_counts[appId] = count;
            this.icon_counts2[appId] = count2;

            //var shadow = button.appendChild(document.createElement("div"));
            //shadow.classList.add("shadow");

            button.addEventListener("click", (e) => {
                var app = TerminalApp.GetApp(appId);
                app.open();
            });
        }

        setAppNumber(appId: string, number: number, number2: number = 0) {
            var elm = this.icon_counts[appId];
            if (elm) {
                elm.style.display = number > 0 ? "block" : "none";
                elm.innerHTML = number.toString();
            }

            var elm2 = this.icon_counts2[appId];
            if (elm2) {
                elm2.style.display = number2 > 0 ? "block" : "none";
                elm2.innerHTML = number2.toString();
            }
        }
    }
    RegisterApp("homescreen", Homescreen);
}